import { setOpenAPIToken } from "@/tanstack-hooks";
import { create } from "zustand";

interface AuthState {
  accessToken: string | null;
  setToken: (accessToken: string) => void;
  clearToken: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  accessToken: null,
  setToken: (accessToken) => {
    setOpenAPIToken(accessToken);
    set({ accessToken });
  },
  clearToken: () => {
    setOpenAPIToken(null);
    set({ accessToken: null });
  },
}));
